var WDN = WDN || {};

// <:::> Potential duplicate, when on recently-viewed page. Could it be combined?
// Recently viewed
if (typeof WDN.RenderViewedProducts === "undefined") {
  WDN.RenderViewedProducts = (function () {
    class RenderViewedProducts {
      constructor(selector, list_selector, list) {
        this.selector = selector;
        this.list_selector = list_selector;
        this.viewedList = list || new ViewedProducts();
      }

      attachNodes() {
        this.container = document.querySelector(this.selector);
        this.productOutput = this.container.querySelector(this.list_selector);
        this.countOutputs = document.querySelectorAll("[data-recently-viewed-count]");
      }

      setupConfig() {
        this.productCardSectionName = this.container.getAttribute("data-recently-viewed-template") || "product-card";
        this.renderMax = this.container.getAttribute("data-recently-viewed-limit") || 20;
      }

      buildRenderableList() {
        this.renderableList = this.viewedList.list.reverse().slice(0, this.renderMax).reverse();
      }

      outputCount() {
        var count = this.viewedList.list.length;
        this.countOutputs.forEach(function (container) {
          container.setAttribute("data-recently-viewed-count", count);
          if (container.getAttribute("data-attribute-only") !== "") {
            container.innerHTML = count;
          }
        });
      }

      render() {
        // verify if we have a list length greater than 0, or set state on container
        if (this.renderableList.length == 0) {
          this.container.setAttribute("data-recently-viewed-products", "empty");
          this.onRender();
          return;
        }

        this.renderableList.forEach((product_handle, index) => {
          this.loadSingle(product_handle, index);
        });

        this.container.setAttribute("data-recently-viewed-products", "rendered");
      }

      renderSingle(product_data, index) {
        var product_renderable_wrapper = document.createElement("div");
        product_renderable_wrapper.setAttribute("data-order-index", index);
        product_renderable_wrapper.classList.add("productHistoryItem", "fi", "fi:1/2", "md-up:fi:1/4", "mb:st", "md-up:mb");
        product_renderable_wrapper.innerHTML = product_data;

        this.productOutput.appendChild(product_renderable_wrapper);
      }

      onRender() {
        if (this.externalConfig && typeof this.externalConfig.onRender === "function") {
          this.externalConfig.onRender();
        }
      }

      loadSingle(product_handle, index) {
        var endPoint = Shopify.routes.root + "products/" + product_handle + "?section_id=" + this.productCardSectionName;
        var renderSingle = this.renderSingle.bind(this);
        var removeFromList = this.viewedList.removeFromList.bind(this);

        WDN.Request.Get({
          url: endPoint,
          onSuccess: function (responseText) {
            var html = new DOMParser().parseFromString(responseText, "text/html");
            if (html.querySelector(".card--product").getAttribute("data-relative-product-url").length == 0) {
              return;
            }

            var item = html.querySelector(".shopify-section").innerHTML;

            renderSingle(item, index);

            // if forloop last
            if (this.renderableList.length - 1 === index) {
              this.onRender();
            }
          }.bind(this),
          onError: function (r) {
            removeFromList(product_handle);
          },
        });
      }

      start(externalConfig) {
        this.externalConfig = externalConfig;
        this.attachNodes();
        this.setupConfig();
        this.buildRenderableList();
        this.render();
        this.outputCount();
      }
    }
    return RenderViewedProducts;
  })();
}

// Wishlist main
if (typeof WDN.Storage === "undefined") {
  WDN.Storage = (function () {
    var Storage = function (config) {
      this.config = {
        storage_type: config.storage_type || localStorage, // LocalStorage or SessionStorage
        storage_key: config.storage_key, // Key that storage is saved under
        storage_limit: config.storage_limit || false, // not implemented yet
      };
      this.value = this.read();
    };

    // Function to find out whether ID is in storage
    Storage.prototype.exists = function (id) {
      var entry_index = this.get_entry_index(id); // returns index or false
      return typeof entry_index === "number";
    };

    // Returns JSON storage value
    Storage.prototype.read = function () {
      var storage_value = this.config.storage_type.getItem(this.config.storage_key);
      return storage_value ? JSON.parse(storage_value) : [];
    };

    // Clears storage
    Storage.prototype.clear = function () {
      this.config.storage_type.removeItem(this.config.storage_key);
      this.value = [];
      this.on_change();
    };

    /**
     * Adds payload to wishlist [id]: {}
     * @param {object} payload
     * @returns
     */
    Storage.prototype.add = function (payload) {
      var value = this.read();
      var payload_id = Object.keys(payload || {})[0];
      if (this.exists(payload_id)) return;

      value.unshift(payload);
      this.set(value);
      this.on_change();
    };

    // Stores value on the instance and in preferred storage
    Storage.prototype.set = function (value) {
      this.value = value;
      this.config.storage_type.setItem(this.config.storage_key, JSON.stringify(value));
    };

    // Gets item's position in storage - by id
    Storage.prototype.get_entry_index = function (id) {
      var found_index = false;
      for (var i = 0; i < this.value.length; i++) {
        var entry = this.value[i];
        if (entry.hasOwnProperty(id)) {
          found_index = i;
          break;
        }
      }
      return found_index;
    };

    // Removes item from storage by id
    Storage.prototype.remove = function (id) {
      var entry_index = this.get_entry_index(id);
      if (typeof entry_index !== "number") return;
      this.value.splice(entry_index, 1);
      this.set(this.value);
      this.on_change();
    };

    Storage.prototype.on_change = function () {
      document.dispatchEvent(
        new CustomEvent("storage:changed", {
          detail: this,
        })
      );
    };

    return Storage;
  })();
}
// Wishlist trigger
(function () {
  // Dependencies
  var Storage = WDN.Storage;

  var config = {
    wishlist_key: "wishlist",
  };

  // Wishlist storage
  var WishlistStorage = new Storage({
    storage_type: localStorage || sessionStorage,
    storage_key: config.wishlist_key,
  });

  class WishlistTrigger extends HTMLElement {
    constructor() {
      super();
      this.handle = this.getAttribute("data-product-handle");
      this.product_name = this.getAttribute("data-product-name");
      this.product_id = this.getAttribute("data-product-id");
      this.product_url = this.getAttribute("data-product-url") || "";
      this.product_image = this.getAttribute("data-product-image") || "";
      this.variant_price = this.getAttribute("data-variant-price");
      this.variant_compareprice = this.getAttribute("data-variant-compareprice");

      this.payload = {
        name: this.product_name,
        variant_id: this.getAttribute("data-variant-id") || false,
        product_id: this.product_id,
        image_src: this.product_image,
        price: this.variant_price,
        compare_at_price: this.variant_compareprice,
        product_url: this.product_url,
      };

      this.Storage = WishlistStorage;

      this.wishlisted = this.Storage.exists(this.handle);

      this.init();
    }

    // Listen for attribute changes
    static get observedAttributes() {
      return ["data-variant-id", "data-variant-price", "data-variant-compareprice"];
    }

    // Handle attribute change
    attributeChangedCallback(attrName, oldVal, newVal) {
      // If value not changed - don't do anything
      if (oldVal === newVal) return;

      switch (attrName) {
        case "data-variant-id":
          this.payload.variant_id = newVal;
          break;
        case "data-variant-price":
          this.payload.price = newVal;
          break;
        case "data-variant-compareprice":
          this.payload.compare_at_price = newVal;
          break;
      }
    }

    on_add() {
      if (typeof _learnq === "undefined") return;
      var payload = [
        "track",
        "Added to Wishlist",
        {
          added: {
            name: this.payload.name,
            variant_id: this.payload.variant_id,
            product_id: this.payload.product_id,
            image_src: this.payload.image_src,
            price: this.payload.price,
            compare_at_price: this.payload.compare_at_price,
            product_url: this.payload.product_url,
          },
          wishlist_items: this.get_wishlist_items(),
        },
      ];

      _learnq.push(payload);
    }

    get_wishlist_items() {
      var storage = this.Storage.read();
      var output = [];

      storage.forEach(function (entry) {
        for (var key in entry) {
          if (entry.hasOwnProperty(key)) {
            output.push(entry[key]);
          }
        }
      });

      return output;
    }

    add_to_storage() {
      this.Storage.add({
        [this.handle]: this.payload,
      });
      a;
      this.fire_event("item:added");
      this.on_add();
    }

    remove_from_storage() {
      this.Storage.remove(this.handle);
      this.fire_event("item:removed");
    }

    fire_event(event_name) {
      var custom_event = new CustomEvent(event_name, {
        detail: this,
      });

      this.dispatchEvent(custom_event);
      document.dispatchEvent(custom_event);
    }

    // function for adding/removing item from the wishlist
    wishlist(state) {
      if (state) {
        this.add_to_storage();
      } else {
        this.remove_from_storage();
      }
      this.wishlist_attribute(state);
      this.wishlisted = state;
    }

    wishlist_attribute(state) {
      if (state) {
        this.setAttribute("data-wishlisted", "");
        return;
      }
      this.removeAttribute("data-wishlisted");
    }

    handle_click() {
      this.wishlist(!this.wishlisted);
    }

    handle_change_event(e) {
      if (e.detail.handle !== this.handle) return;
      this.wishlisted = this.Storage.exists(this.handle);
      this.wishlist_attribute(this.wishlisted);
    }

    listen_for_events() {
      this.addEventListener("click", this.handle_click);
      // We use these in case there are duplicate instances on the page
      document.addEventListener("item:added", this.handle_change_event.bind(this));
      document.addEventListener("item:removed", this.handle_change_event.bind(this));
    }

    init() {
      this.wishlist_attribute(this.wishlisted); // setting initial layout
      this.listen_for_events();
    }
  }

  if (!customElements.get("wishlist-trigger")) {
    customElements.define("wishlist-trigger", WishlistTrigger);
  }

  // Global Wishlist - indicator, clearers
  var init, listen_for_events, handle_storage_change;
  var set_initial_value, set_value, handle_clear_click, on_add_event;
  var on_wishlist_count_event;

  var nodes = {
    indicators: document.querySelectorAll("[data-wishlist-count]"),
    clear_triggers: document.querySelectorAll("[data-wishlist-clear]"),
  };

  set_value = function (new_value) {
    nodes.indicators.forEach(function (indicator) {
      indicator.setAttribute("data-wishlist-count", new_value);
      if (indicator.getAttribute("data-attribute-only") !== "") {
        indicator.innerHTML = new_value;
      }
    });
  };

  set_initial_value = function () {
    set_value(WishlistStorage.read().length);
  };

  handle_storage_change = function (e) {
    if (e.detail.config.storage_key == !config.wishlist_key) return;
    set_value(e.detail.value.length);
  };

  handle_clear_click = function () {
    WishlistStorage.clear();
  };

  on_wishlist_count_event = function () {
    nodes.indicators = document.querySelectorAll("[data-wishlist-count]");
    set_value(WishlistStorage.read().length);
  };

  listen_for_events = function () {
    // listens for wishlist change
    document.addEventListener("storage:changed", handle_storage_change);
    // change dispatch of "cartlayout:updated" into "wishlistcount:update" if event used only on one place
    // afterwards remove this listener
    document.addEventListener("cartlayout:updated", on_wishlist_count_event);
    document.addEventListener("wishlistcount:update", on_wishlist_count_event);

    // listens for clear wishlist
    nodes.clear_triggers.forEach(function (trigger) {
      trigger.addEventListener("click", handle_clear_click);
    });
  };

  init = function () {
    if (nodes.indicators.length === 0) return;
    set_initial_value();
    listen_for_events();
  };

  init();
})();

// Wishlist output
if (typeof WDN.StorageOutput === "undefined") {
  WDN.StorageOutput = function (external_config) {
    // Required config validation
    if (!external_config.storage_key || !external_config.name) {
      console.warn("Storage missing required fields!");
      return;
    }
    // Dependencies
    var Storage = WDN.Storage;
    var Routes = Shopify.routes;

    // Constructor storage
    var ConstructorStorage = new Storage({
      storage_type: external_config.storage_type || localStorage,
      storage_key: external_config.storage_key,
    });

    /* Constructor output start */
    var init, get_fetch_url, fetch_layout, inject_content, show_blank_layout;
    var on_fetch_success, assign_new_nodes, handle_item_remove, listen_for_events;
    var inject_pagination, handle_pagination_click, loading, content_containers_hide;
    var listen_for_storage_change, handle_storage_change;

    var nodes = {
      output: document.querySelector("[data-" + external_config.name + "-output]"),
      blank_layout: document.querySelector("[data-" + external_config.name + "-blank]"),
      hide_on_blanks: document.querySelectorAll("[data-" + external_config.name + '-hide="blank"]'),
      pagination_template: document.querySelector("[data-" + external_config.name + "-pagination-template]"),
    };

    var config = {
      section_id: external_config.section_id,
      paginate_by: external_config.paginate_by || ConstructorStorage.value.length,
    };

    get_fetch_url = function (handle) {
      return Routes.root + "products/" + handle + "?section_id=" + config.section_id;
    };

    inject_content = function (content) {
      nodes.output.insertAdjacentHTML("beforeend", content);
    };

    inject_pagination = function () {
      if (!nodes.pagination_template) return;
      var template_clone = nodes.pagination_template.content.cloneNode(true);
      nodes.output.appendChild(template_clone);
    };

    content_containers_hide = function (state) {
      var action = state ? "add" : "remove";
      nodes.hide_on_blanks.forEach(function (container) {
        container.classList[action]("hidden");
      });
    };

    show_blank_layout = function () {
      if (!nodes.blank_layout) return;
      content_containers_hide(true);
      nodes.blank_layout.classList.remove("hidden");
    };

    on_fetch_success = function () {
      assign_new_nodes();
      content_containers_hide(false);
      listen_for_events();
      loading(false);
    };

    loading = function (state) {
      var target = document.body;
      if (state) {
        target.setAttribute("data-loading", "");
      } else {
        target.removeAttribute("data-loading");
      }
    };

    fetch_layout = function (fetch_config) {
      loading(true);
      var queue_list = ConstructorStorage.read();
      var content = [];
      var handle_list = [];

      if (queue_list.length === 0) {
        loading(false);
        return;
      }

      queue_list.every(function (item, i) {
        var handle = Object.keys(item)[0];
        var url = get_fetch_url(handle);
        handle_list.push(handle);

        if (external_config.output_limit && i >= external_config.output_limit) {
          return false; // stops loop
        }

        fetch(url, {
          method: "GET",
        })
          .then(function (res) {
            return res.ok ? res.text() : Promise.reject(res);
          })
          .then(function (res) {
            content.push(res); // pushing content to array to get an overview of rendered items
            inject_content(res.replace("<div", "<div style='order:" + handle_list.indexOf(handle) + ";' data-wishlist-item='" + handle + "'"));
            // last fetch/forloop last
            var output_limit_hit = external_config.output_limit && content.length >= external_config.output_limit;
            if (content.length === queue_list.length || output_limit_hit) {
              if (fetch_config && typeof fetch_config.on_success === "function") {
                fetch_config.on_success();
              }
              on_fetch_success();
            }
          })
          .catch(function (err) {});

        return true; // continues loop
      });
    };

    assign_new_nodes = function () {
      nodes.triggers = document.querySelectorAll("[data-" + external_config.name + "-trigger]");
      nodes.pagination = document.querySelector("[data-" + external_config.name + "-pagination]");
    };

    handle_item_remove = function (e) {
      var item_card = document.querySelector("[data-" + external_config.name + "-item='" + e.detail.handle + "']");
      if (!item_card) return;

      item_card.remove();

      if (ConstructorStorage.read().length === 0) {
        show_blank_layout();
      }
    };

    handle_pagination_click = function () {
      fetch_layout();
      this.parentNode.remove();
    };

    listen_for_events = function () {
      nodes.triggers.forEach(function (trigger) {
        trigger.addEventListener("item:removed", handle_item_remove);
      });

      if (nodes.pagination) {
        nodes.pagination.addEventListener("click", handle_pagination_click);
      }
    };

    handle_storage_change = function (e) {
      if (e.detail.config.storage_key !== ConstructorStorage.config.storage_key) return;
      var items_to_remove = nodes.output.querySelectorAll("[data-wishlist-item]");
      loading(true);
      fetch_layout({
        on_success: function () {
          items_to_remove.forEach(function (item) {
            item.remove();
          });
          loading(false);
        },
      });
    };

    listen_for_storage_change = function () {
      document.addEventListener("storage:changed", handle_storage_change);
    };

    init = function () {
      if (!nodes.output) return;

      if (external_config.rerender_on_change) {
        listen_for_storage_change();
      }

      if (ConstructorStorage.read().length === 0) {
        show_blank_layout();
        return;
      }

      fetch_layout();
    };

    init();

    return {
      storage: ConstructorStorage,
    };
  };
}
